let html = `
<svg><use xlink:href="#sprite-search"></use></svg>
`

export default html